import styled from 'styled-components'

export const ContentContainer = styled.section``
